import React from "react";
import { Link } from "react-router-dom";

const Button = ({
  text,
  to,
  href,
  size = "md",
  bgGradient = "bg-gradient-to-r from-blue-500 to-blue-700",
  textColor = "text-white",
  className = "",
  align = "left", // 🔥 new prop: left | center | right
}) => {
  const baseStyle =
    "font-semibold rounded-full transition-transform duration-300 transform hover:scale-105 inline-block text-center shadow-md";

  const sizeStyles = {
    sm: "px-4 py-2 text-sm",
    md: "px-6 py-3 text-base",
    lg: "px-8 py-4 text-lg",
  };

  const alignMap = {
    left: "justify-start",
    center: "justify-center",
    right: "justify-end",
  };

  const content = (
    <span
      className={`${baseStyle} ${sizeStyles[size]} ${bgGradient} ${textColor} ${className}`}
    >
      {text}
    </span>
  );

  // wrap in flex container for alignment
  const wrapper = <div className={`flex ${alignMap[align]}`}>{content}</div>;

  if (to) return <Link to={to}>{wrapper}</Link>;
  if (href) return <a href={href} target="_blank" rel="noopener noreferrer">{wrapper}</a>;

  return wrapper;
};

export default Button;
